/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const getJobsRequestDataSchema = z.object({
	statuses: z.string().nullable().optional(),
	cursor: z.string().nullable().optional(),
	nameContains: z.string().nullable().optional(),
	pageSize: z.number().optional().default(10),
})

export type GetJobsRequestDataSchema = z.infer<typeof getJobsRequestDataSchema>
